document.addEventListener('DOMContentLoaded', function() {

  const copyButtons = document.querySelectorAll('.nxa-block-hero-splitscreen [data-action="copy"]');

  copyButtons.forEach(button => {
    button.addEventListener('click', function() {
      const url = this.getAttribute('data-url');

      navigator.clipboard.writeText(url).then(() => {
        // Feedback für User
        const originalLabel = this.getAttribute('aria-label');
        this.classList.add('copied');
        this.setAttribute('aria-label', 'Link kopiert!');

        // Nach 2 Sekunden zurücksetzen
        setTimeout(() => {
          this.classList.remove('copied');
          this.setAttribute('aria-label', originalLabel);
        }, 2000);
      }).catch(err => {
        console.error('Kopieren fehlgeschlagen:', err);
        // Fallback für ältere Browser
        fallbackCopyToClipboard(url, this);
      });
    });
  });

  // Fallback für Browser ohne Clipboard API
  function fallbackCopyToClipboard(text, button) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    document.body.appendChild(textArea);
    textArea.select();

    try {
      document.execCommand('copy');
      button.classList.add('copied');
      setTimeout(() => button.classList.remove('copied'), 2000);
    } catch (err) {
      console.error('Fallback kopieren fehlgeschlagen:', err);
    }

    document.body.removeChild(textArea);
  }

  // Höhenunterschied zwischen image und other beobachten
  const blocks = document.querySelectorAll('.nxa-block-hero-splitscreen');
  const mediaQuery = window.matchMedia('(min-width: 768px)');
  let observers = [];

  function updatePadding(block, image, other) {
    other.style.paddingTop = '';
    const firstChild = other.firstElementChild;
    if (!firstChild) return;
    const naturalGap = firstChild.getBoundingClientRect().top - block.getBoundingClientRect().top;
    if (naturalGap < 56) {
      other.style.paddingTop = `${56 - naturalGap}px`;
    }
  }

  function enable() {
    blocks.forEach(block => {
      const image = block.querySelector('.image');
      const other = block.querySelector('.other');

      if (!image || !other) return;
      let isUpdating = false;

      const observer = new ResizeObserver(() => {
        if (isUpdating) return;
        isUpdating = true;
        requestAnimationFrame(() => {
          updatePadding(block, image, other);
          isUpdating = false;
        });
      });

      observer.observe(image);
      observer.observe(other);
      observers.push(observer);

      // Initial calculation
      updatePadding(block, image, other);
    });
  }

  function disable() {
    observers.forEach(observer => observer.disconnect());
    observers = [];

    blocks.forEach(block => {
      const other = block.querySelector('.other');
      if (other) {
        other.style.paddingTop = '';
      }
    });
  }

  function handleMediaChange() {
    if (mediaQuery.matches) {
      enable();
    } else {
      disable();
    }
  }

  // Initial setup
  handleMediaChange();

  // Listen for media query changes
  mediaQuery.addEventListener('change', handleMediaChange);

});
